import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed z-20 inset-0 overflow-y-auto"
}
const _hoisted_2 = { class: "flex justify-center items-center h-full" }
const _hoisted_3 = {
  class: "m-3 p-3 bg-white rounded overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "modal-headline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ]))]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}